import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';

const headersObject = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
};

type customHeader = {
  subdomain: string;
  facilityId: string;
  token: string;
};
class FacilityService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getAssignedFacilities = () => {
    return this.axiosInstance.get(apiPath.ASSIGNED_FACILITIES);
  };

  swicthFacility = (uuid: string) => {
    return this.axiosInstance.put(`${apiPath.SWITCH_FACILITY}${uuid}`);
  };

  getPreAssignedFacilities = (payload: customHeader) => {
    return this.axiosInstance.get(apiPath.ASSIGNED_FACILITIES, {
      headers: {
        Authorization: payload.token,
        Facility_id: payload.facilityId,
        'X-TENANT-ID': payload.subdomain,
        ...headersObject,
      },
    });
  };
}

const facilityService = new FacilityService();

Object.freeze(facilityService);

export default facilityService;
